import './spec.scss';

interface Icon {
    src: string;
    caption: string;
}

interface SpecProps {
    icons: Icon[]
}

const SpecComponent: React.FC<SpecProps> = ({ icons }) => {

    return (
        <>
            <div className='spec'>
                {icons.map((icon, index) => (
                    <div key={index} className='spec-icon'>
                        <img src={icon.src} alt='icon' />
                        <h4>{icon.caption}</h4>
                    </div>
                ))}
            </div>
        </>
    )
}

export default SpecComponent;
